import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { EmailAuthProvider, getAuth, reauthenticateWithCredential } from 'firebase/auth';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import {
  BUTTON_LABEL_CANCEL,
  ERROR_INVALID_PASSWORD,
  ERROR_NOT_LOGGED_IN,
  KEY_CODE_RETURN,
  BUTTON_LABEL_VERIFY,
} from '../../calvin-emr-shared/global';
import { CalvinEMRSharedModule } from '../../calvin-emr-shared/calvin-emr-shared.module';
import { NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';

export interface LoginDialogData {
  prompt: string;
  cancelButtonLabel: string;
  verifyButtonLabel: string;
}

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    standalone: true,
    imports: [
        CalvinEMRSharedModule,
        NgIf,
        ButtonDirective,
    ],
})
export class LoginDialogComponent implements OnInit {
  prompt: string = 'Please enter your current password to verify that it is truly you:';
  cancelButtonLabel: string = BUTTON_LABEL_CANCEL;
  verifyButtonLabel: string = BUTTON_LABEL_VERIFY;

  label = 'Enter your current password';
  password: UntypedFormControl = new UntypedFormControl('', [Validators.required]);
  passwordSub: Subscription;
  error = '';

  /**
   * Change the dialog's labels based on data passed in from the caller, if any.
   * Subscribe to the password valueChanges to clear any errors when the user
   * begins typing in the password form field.
   *
   * @param dialogRef The reference to this dialog.
   * @param config The configuration (including data) injected into this dialog.
   */
  constructor(public dialogRef: DynamicDialogRef, public config: DynamicDialogConfig) {
    if (config.data) {
      if (config.data.prompt) this.prompt = config.data.prompt;
      if (config.data.cancelButtonLabel) this.cancelButtonLabel = config.data.cancelButtonLabel;
      if (config.data.verifyButtonLabel) this.verifyButtonLabel = config.data.verifyButtonLabel;
    }
    this.passwordSub = this.password.valueChanges.subscribe(() => {
      this.error = '';
    });
  }

  ngOnInit(): void {}

  /**
   * Calls the onVerify function when the "Enter/Return" key is pressed.
   *
   * @param event Object passed by (keyup) property of input tag.
   */
  handleKeyUp(event: any) {
    if (event.keyCode == KEY_CODE_RETURN) {
      this.onVerify();
    }
  }

  /**
   *
   */
  onVerify(): void {
    const auth = getAuth();
    const user = auth.currentUser;
    const email = user?.email;

    if (user && email) {
      const credential = EmailAuthProvider.credential(email, this.password.value);
      reauthenticateWithCredential(user, credential)
        .then(() => {
          this.dialogRef.close(true);
        })
        .catch(() => {
          this.error = ERROR_INVALID_PASSWORD;
        });
    } else {
      this.error = ERROR_NOT_LOGGED_IN;
    }
  }

  /**
   * Send a false value back to the caller, indicating that the user
   * cancelled.
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

  get hasError(): boolean {
    return this.error != null && this.error != '';
  }
}
